module.exports = __webpack_public_path__ + "static/img/3_light.71fcc50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/3_light.png
// module id = Ku9Z
// module chunks = 0